import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-astsyllabus',
    templateUrl: './astsyllabus.component.html',
    styleUrls: ['./astsyllabus.component.scss']
})
export class AstsyllabusComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
